import React from 'react'
import styles from './TabellaVolantini.module.sass'
import { TabellaDatiTecniciNode } from '@gql/graphql'
import { Button, EditableTitle, WContainer, WImage } from '@components/atoms'
import useTrans from '@hooks/useTrans'

interface Props {
  className?: string
  tabellaDatiTecnici?: TabellaDatiTecniciNode
  hideCtas?: boolean
  nextImage?: boolean
}

const TabellaVolantini = (props: Props) => {
  const { tabellaDatiTecnici, className = '', hideCtas = false, nextImage = false } = props
  const { attributi, prodotti } = tabellaDatiTecnici

  const t = useTrans()

  return (
    <div className={`${styles.root} ${className}`}>
      <WContainer>
        <EditableTitle variant="h2" title={t('Dati tecnici')} className={styles.title} />
        <table>
          <thead>
            <tr>
              <td className={styles.attributo}>{t('Modello')}</td>
              {prodotti.map(({ prodotto }) => (
                <th key={prodotto.pk}>
                  <div className={styles.imageBox}>
                    <WImage
                      src={prodotto.previewImage}
                      alt={prodotto.nome}
                      maxWidth={90}
                      maxHeight={90}
                      next={nextImage}
                    />
                  </div>
                  <span>{prodotto.nome}</span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {attributi.map((attributo, index) => (
              <tr key={index}>
                <td className={styles.attributo}>{attributo}</td>
                {prodotti.map((p) => (
                  <td key={`${p.prodotto.pk}-${index}`} className={styles.prodotto}>
                    {p.valori?.[index] || '-'}
                  </td>
                ))}
              </tr>
            ))}
            {!hideCtas && (
              <tr>
                <td></td>
                {prodotti.map(({ prodotto }) => (
                  <td key={`cta-${prodotto.pk}`} className={styles.ctaCell}>
                    <Button href={prodotto.url} size="lg" label={t('Acquista')} />
                  </td>
                ))}
              </tr>
            )}
          </tbody>
        </table>
      </WContainer>
    </div>
  )
}

export default TabellaVolantini
